import { render, staticRenderFns } from "./NewMonthList.vue?vue&type=template&id=079fcbc2&scoped=true&"
import script from "./NewMonthList.vue?vue&type=script&lang=ts&"
export * from "./NewMonthList.vue?vue&type=script&lang=ts&"
import style0 from "./NewMonthList.vue?vue&type=style&index=0&id=079fcbc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fcbc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
